import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.814 3.748c0-.432.354-.748.749-.748h4.367c2.884 0 5.256 2.276 5.256 5.127 0 2.4-1.682 4.393-3.936 4.963l3.842 6.635a.7.7 0 0 1-1.211.701l-4.154-7.173H8.214V20.3a.7.7 0 1 1-1.4 0V3.748Zm1.4 8.105h3.716c2.149 0 3.857-1.687 3.857-3.726 0-2.04-1.708-3.727-3.857-3.727H8.214v7.453Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
